import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { AppNameField } from './AppNameField';

export const AppNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AppNameField',
    component: AppNameField,
  }),
);
